<template>
  <b-modal id="finishedTaskDocumentModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.finishedTaskDocument.finishedTaskDocumentHeader') }}</h6>
      </b-col>
    </b-row>
    <FinishedTaskDocument v-if="task" :task="task"></FinishedTaskDocument>
  </b-modal>
</template>

<script>
import FinishedTaskDocument from './FinishedTaskDocument'
export default {
  name: 'FinishedTaskDocumentModal',
  components: {
    FinishedTaskDocument
  },
  computed: {
    show () {
      return this.$store.state.modals.finishedtaskdocument.create.show
    },
    taskObject () {
      return this.$store.state.modals.finishedtaskdocument.create.task
    },
    close () {
      return this.$store.state.modals.finishedtaskdocument.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'taskObject': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      task: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.taskObject) {
        this.task = Object.assign({}, this.taskObject)
        this.$store.state.modals.finishedtaskdocument.create.show = 0
        this.$store.state.modals.finishedtaskdocument.create.task = null
        this.$bvModal.show('finishedTaskDocumentModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.finishedtaskdocument.create.close = 0
        this.$emit('success')
      }
      this.$bvModal.hide('finishedTaskDocumentModal')
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
